import { getAppConfig } from '@/config/config'

export const getLinkPathname = (url: string): string => {
  if (!url) {
    return ''
  }

  return new URL(url).pathname
}

/**
 * Rewrites the links in the given value to ensure they point to the correct paths.
 * In CUE the publication is configured as subdomain of n-tv.de, but the links in the CMS data point to sport.n-tv.de. This function rewrites those links to point to www.n-tv.de and also adds the basePath.
 * @param value
 */
export const rewriteLinks = (value: string): string => {
  const config = getAppConfig()
  const basePath = config.basePath

  return value
    .replaceAll('sport.n-tv.de', 'www.n-tv.de')
    .replaceAll('www.n-tv.de/mediathek/', `www.n-tv.de${basePath}/mediathek/`)
}
